import React from 'react';

import classnames from 'classnames2';

import { Label } from '../../Label';

import styles from './Select.Label.module.scss';

export interface ISelectLabelProps {
  /** The text to be displayed on the label. */
  text: string;
  /** The indentation level of this label. Should be a number between 0 and 4. */
  indentLevel?: number;
  /** Whether the label should be disabled */
  disabled?: boolean;
}

export const SelectLabel: React.SFC<ISelectLabelProps> = (props) => (
  <div
    aria-hidden={true}
    className={classnames(styles.label, styles[`indentation${props.indentLevel}`], {
      [styles.disabled]: props.disabled
    })}
  >
    <Label variant="group" disabled={props.disabled}>
      {props.text}
    </Label>
  </div>
);

SelectLabel.displayName = 'Select.Label';

SelectLabel.defaultProps = {
  indentLevel: 0
};
